import Dropdown from '../dropdown/Dropdown';
import { twMerge } from 'tailwind-merge';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// import { IoMenuOutline } from 'react-icons/io5';
// import { MdGridView } from 'react-icons/md';

const Search = ({ numberOfAds, className = '', setSearchText, searchText, sortOption, setSortOption }) => {
  const { t } = useTranslation();
  const [textValue, setTextValue] = useState(sortOption || 'newest');
  const { category } = useSelector((state) => state.categoryStore);

  const isTourismCategory = category?.key === 'tourismAndVacation';

  // Sync textValue with sortOption prop
  useEffect(() => {
    if (sortOption) {
      setTextValue(sortOption);
    }
  }, [sortOption]);

  return (
    <div className={twMerge(className)}>
      {/* <div className='flex flex-col justify-normal p-0 pl-[1.625rem] pt-3 max-2xl:pr-[1.625rem] sm:flex-row sm:justify-between md:mt-[2.875rem] md:pt-0'> */}
      <div className='pt-3 break55:pt-0'>
        {/* <h1 className='pb-[1.3125rem] pl-[1.625rem] pt-[1.065rem] text-center  text-[0.875rem] leading-[1.125rem] text-[#2C2C2C] sm:pr-3 sm:text-left'> */}
        <h1 className='pb-[1.3125rem] pt-[1.065rem] text-[0.875rem] leading-[1.125rem] text-[#2C2C2C] sm:pl-[1.625rem] sm:pr-3 sm:text-left'>
          {numberOfAds} {t('results')}
        </h1>
      </div>
      {/* <div className='flex h-[3.88rem] flex-row  place-items-center px-6  text-[1.13rem] font-light leading-[1.375rem] text-[#999999] max-2xl:pr-[1.625rem]'> */}
      <div className='grid w-full items-center gap-4  text-[1.13rem] font-medium leading-[1.375rem] text-black md:grid break9:flex'>
        <input
          type='text'
          name='search'
          id='#search'
          placeholder={`${t('placeholder')}`}
          // className='mr-3 h-14 w-full rounded-[0.5rem] px-5 shadow-md'
          className='border-gray w-full rounded-[0.5rem] border-[1px] px-5 py-[17px] sm:pl-[1.625rem]'
          onChange={(e) => setSearchText(e?.target?.value)}
          value={searchText}
        />
        {/* <div className='flex items-center justify-center gap-2 sm:justify-normal'> */}
        <div className='flex gap-2'>
          <div className='w-full break9:w-48'>
            <Dropdown
              className='border-gray h-14 w-full justify-between gap-2 border-[1px] pr-4 text-base font-light shadow-none'
              dropdownClass='w-full z-50 top-16 px-2 py-2'
              titleClass='pl-8 break9:pl-4'
              options={(handleItemClick) => (
                <>
                  <li
                    className='w-full rounded-md px-2 hover:shadow-md'
                    onClick={() => {
                      handleItemClick(() => {
                        if (setSortOption) {
                          setSortOption('newest');
                        }
                      });
                    }}
                  >
                    {t('newest')}
                  </li>
                  <li
                    className='w-full rounded-md px-2 hover:shadow-md'
                    onClick={() => {
                      handleItemClick(() => {
                        if (setSortOption) {
                          setSortOption('oldest');
                        }
                      });
                    }}
                  >
                    {t('oldest')}
                  </li>
                  {isTourismCategory && (
                    <>
                      <li
                        className='w-full rounded-md px-2 hover:shadow-md'
                        onClick={() => {
                          handleItemClick(() => {
                            if (setSortOption) {
                              setSortOption('priceLow');
                            }
                          });
                        }}
                      >
                        {t('priceLow')}
                      </li>
                      <li
                        className='w-full rounded-md px-2 hover:shadow-md'
                        onClick={() => {
                          handleItemClick(() => {
                            if (setSortOption) {
                              setSortOption('priceHigh');
                            }
                          });
                        }}
                      >
                        {t('priceHigh')}
                      </li>
                    </>
                  )}
                </>
              )}
              text={t(textValue)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
